var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextUnderline = function SvgIconTextUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25a1 1 0 0 0-2 0v5.625a7 7 0 1 0 14 0V5.25a1 1 0 1 0-2 0v5.625a5 5 0 1 1-10 0zM3.75 19.25a1 1 0 1 0 0 2h16.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconTextUnderline;